import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

export var userListRes;
export const userListTodo = createAsyncThunk('userList', async (data) => {
    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'user',
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + localStorage.getItem('token')
            },
            params: {
                "status": data?.values?.status || '',
                "user_role": data?.values?.role || '',
                "department": data?.values?.department || '',
                "designation": data?.values?.designation || ''
            }
        });

        // ✅ Return only serializable values
        return res

    } catch (error) {
        return error?.response

    }
});

const userListSlice = createSlice({
    name: 'userList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(userListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                localStorage.clear();
                action?.meta?.arg?.navigate('./login');
            }
            else if (action?.payload?.status === 400 || action?.payload?.status === 404) {
                state.data = [];
            } else {
                state.data = [];
            }
        });
        builder.addCase(userListTodo.rejected, (state, action) => {
            // optional: console.log('token_error', action)
        });
    }
});

export default userListSlice.reducer;
